import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule,APP_INITIALIZER } from '@angular/core';
import { HttpClient,HttpClientModule } from '@angular/common/http';
import {FormBuilder, ReactiveFormsModule, FormsModule, NgControl, FormGroup } from '@angular/forms';
import {NgxMaskModule, IConfig} from 'ngx-mask';
import { RecaptchaModule } from 'ng-recaptcha';
import { AgGridModule } from 'ag-grid-angular';
import {NgbModule,NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { FileUploadModule  } from 'ng2-file-upload';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'; 
import { MomentModule } from 'angular2-moment';
import { CookieService } from "angular2-cookie/services/cookies.service";



import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { AppRoutingModule } from './/app-routing.module';
import {LoginService} from './login.service';
import { LoaderComponent } from './loader/loader.component';
import { ClientinfoComponent } from './clientinfo/clientinfo.component';
import { LeftnavComponent } from './leftnav/leftnav.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { HouseholdComponent } from './household/household.component';
import { EmploymentsummaryComponent } from './employmentsummary/employmentsummary.component';
import { ClientsummaryComponent } from './clientsummary/clientsummary.component';
import { EligibilitysummaryComponent } from './eligibilitysummary/eligibilitysummary.component';
import { EnrollmentsummaryComponent } from './enrollmentsummary/enrollmentsummary.component';
import { AppointmentsComponent } from './appointments/appointments.component';
import { ParticipationComponent } from './participation/participation.component';
import { TrackcomponentComponent } from './trackcomponent/trackcomponent.component';
import { SummaryComponent } from './summary/summary.component';
import { InformalworkfareComponent } from './informalworkfare/informalworkfare.component';
import { InputrendererComponent } from './inputrenderer/inputrenderer.component';
import { GridviewComponent } from './gridview/gridview.component';
import { DocumentsComponent } from './documents/documents.component';
import { CorrespondenceComponent } from './correspondence/correspondence.component';
import { NoticesComponent } from './notices/notices.component';
import { RequestsComponent } from './requests/requests.component';
import { AppointmentrequestComponent } from './appointmentrequest/appointmentrequest.component';
import { GoodcauseComponent } from './goodcause/goodcause.component';
import { ExemptionComponent } from './exemption/exemption.component';
import { NgbDateCustomParserFormatter} from './dateformat';
import { AlertsComponent } from './alerts/alerts.component';
import { ResourcesComponent } from './resources/resources.component';
import { ContactusComponent } from './contactus/contactus.component';
import { MapComponent } from './map/map.component';
import {NgbdDatepickerBasic} from './appointmentrequest/datepicker.module';
import { ProfileComponent } from './profile/profile.component';
import { ProgressbarComponent } from './progressbar/progressbar.component';
import { DeleteComponent } from './delete/delete.component';
import { RequestSummaryComponent } from './request-summary/request-summary.component';
import { AcknowledgeComponent } from './acknowledge/acknowledge.component';
import { ResourceUrlComponent } from './resource-url/resource-url.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from './interceptor';
import {ServerConstantsService} from './serverConstants.service';
import { PasswordComponent } from './password/password.component';
import { SurveyComponent } from './survey/survey.component';
import { TimeoutComponent } from './timeout/timeout.component';
import { FaqsComponent } from './faqs/faqs.component';
import { DatePipe } from '@angular/common';
import { ValidationDirective } from './validation.directive';
import { AlertHistoryComponent } from './alert-history/alert-history.component';
import { HelpComponent } from './help/help.component';
import { UnavailableComponent } from './unavailable/unavailable.component';
import { RedirectComponent } from './redirect/redirect.component';
import { UrlSerializerService } from './url-serializer';
import {DefaultUrlSerializer, UrlSegment, UrlSerializer, UrlTree} from '@angular/router';

//export const options: Partial<IConfig> | (() => Partial<IConfig>);
export const ServerConstantsFactory = (serverConstants: ServerConstantsService) => {
  return () => {
    return serverConstants.loadConstants();
  };
};

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    LoaderComponent,
    ClientinfoComponent,
    LeftnavComponent,
    DashboardComponent,
    HeaderComponent,
    FooterComponent,
    HouseholdComponent,
    EmploymentsummaryComponent,
    ClientsummaryComponent,
    EligibilitysummaryComponent,
    EnrollmentsummaryComponent,
    AppointmentsComponent,
    ParticipationComponent,
    TrackcomponentComponent,
    SummaryComponent,
    InformalworkfareComponent,
    InputrendererComponent,
    GridviewComponent,
    DocumentsComponent,
    CorrespondenceComponent,
    NoticesComponent,
    RequestsComponent,
    AppointmentrequestComponent,
    GoodcauseComponent,
    ExemptionComponent,
    AlertsComponent,
    ResourcesComponent,
    ContactusComponent,
    MapComponent,
    NgbdDatepickerBasic,
    ProfileComponent,
    ProgressbarComponent,
    DeleteComponent,
    RequestSummaryComponent,
    AcknowledgeComponent,
    ResourceUrlComponent,
    PasswordComponent,
    SurveyComponent,
    TimeoutComponent,
    FaqsComponent,
    ValidationDirective,
    AlertHistoryComponent,
    HelpComponent,
    UnavailableComponent,
    RedirectComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FileUploadModule,
    AppRoutingModule,
    NgbModule.forRoot(),
    ToastrModule.forRoot({progressBar:true,progressAnimation:'increasing'}),
    FormsModule,
    HttpClientModule,
    RecaptchaModule,
    MomentModule,
    NgIdleKeepaliveModule.forRoot(),
    AgGridModule.withComponents([InputrendererComponent,GridviewComponent,ProgressbarComponent,DeleteComponent,AcknowledgeComponent,ResourceUrlComponent]),
    NgxMaskModule.forRoot()
  ],
  providers: [CookieService,LoginService,ServerConstantsService,DatePipe,{provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter},{
    provide: HTTP_INTERCEPTORS,
    useClass: TokenInterceptor,
    multi: true
  },
  {
    provide: UrlSerializer,
    useClass: UrlSerializerService
  },
  { provide: APP_INITIALIZER, useFactory: ServerConstantsFactory, multi: true, deps: [ServerConstantsService] }],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts